/**
 * RoomMask
 *
 * Exports:
 * - <RoomMaskDefs />: invisible inline SVG with objectBoundingBox clipPath.
 *   Use on any element via `clipPath: url(#room-mask-obbox)`.
 * - MASK_SVG_PATH: the raw path in 150×150 coordinates for the MaskOverlay.
 */

export const MASK_SVG_PATH =
    "M53.5078 0.25H96.4932C98.5642 0.25 100.243 1.92893 100.243 4V6.34473C100.243 8.69194 102.146 10.5947 104.493 10.5947H120.877C122.948 10.5947 124.627 12.2737 124.627 14.3447V20.3838C124.627 22.731 126.53 24.6338 128.877 24.6338H134.916C136.987 24.6338 138.666 26.3127 138.666 28.3838V45.5068C138.666 47.854 140.569 49.7568 142.916 49.7568H146C148.071 49.7568 149.75 51.4358 149.75 53.5068V96.4922C149.75 98.5633 148.071 100.242 146 100.242H142.916C140.569 100.242 138.666 102.145 138.666 104.492V120.138C138.666 122.209 136.987 123.888 134.916 123.888H128.877C126.53 123.888 124.627 125.79 124.627 128.138V134.178C124.627 136.249 122.948 137.928 120.877 137.928H104.493C102.146 137.928 100.243 139.831 100.243 142.178V146C100.243 148.071 98.5642 149.75 96.4932 149.75H53.5078C51.4367 149.75 49.7578 148.071 49.7578 146V142.178C49.7578 139.831 47.855 137.928 45.5078 137.928H29.123C27.052 137.928 25.373 136.249 25.373 134.178V128.138C25.373 125.79 23.4703 123.888 21.123 123.888H15.083C13.0119 123.888 11.333 122.209 11.333 120.138V104.492C11.333 102.145 9.43022 100.242 7.08301 100.242H4C1.92893 100.242 0.25 98.5633 0.25 96.4922V53.5068C0.25 51.4358 1.92893 49.7568 4 49.7568H7.08301C9.43022 49.7568 11.333 47.854 11.333 45.5068V28.3838C11.333 26.3127 13.0119 24.6338 15.083 24.6338H21.123C23.4703 24.6338 25.373 22.731 25.373 20.3838V14.3447C25.373 12.2737 27.052 10.5947 29.123 10.5947H45.5078C47.855 10.5947 49.7578 8.69194 49.7578 6.34473V4C49.7578 1.92893 51.4367 0.25 53.5078 0.25Z";

const normalizedPath = [
    "M0.3567 0.0017",
    "H0.6433",
    "C0.6571 0.0017 0.6683 0.0129 0.6683 0.0267",
    "V0.0423",
    "C0.6683 0.0580 0.6810 0.0706 0.6966 0.0706",
    "H0.8058",
    "C0.8197 0.0706 0.8308 0.0818 0.8308 0.0956",
    "V0.1359",
    "C0.8308 0.1515 0.8435 0.1642 0.8592 0.1642",
    "H0.8994",
    "C0.9133 0.1642 0.9244 0.1754 0.9244 0.1892",
    "V0.3034",
    "C0.9244 0.3190 0.9371 0.3317 0.9528 0.3317",
    "H0.9733",
    "C0.9871 0.3317 0.9983 0.3429 0.9983 0.3567",
    "V0.6433",
    "C0.9983 0.6571 0.9871 0.6683 0.9733 0.6683",
    "H0.9528",
    "C0.9371 0.6683 0.9244 0.6810 0.9244 0.6966",
    "V0.8009",
    "C0.9244 0.8147 0.9133 0.8259 0.8994 0.8259",
    "H0.8592",
    "C0.8435 0.8259 0.8308 0.8386 0.8308 0.8542",
    "V0.8945",
    "C0.8308 0.9083 0.8197 0.9195 0.8058 0.9195",
    "H0.6966",
    "C0.6810 0.9195 0.6683 0.9322 0.6683 0.9479",
    "V0.9733",
    "C0.6683 0.9871 0.6571 0.9983 0.6433 0.9983",
    "H0.3567",
    "C0.3429 0.9983 0.3317 0.9871 0.3317 0.9733",
    "V0.9479",
    "C0.3317 0.9322 0.3190 0.9195 0.3034 0.9195",
    "H0.1942",
    "C0.1803 0.9195 0.1692 0.9083 0.1692 0.8945",
    "V0.8542",
    "C0.1692 0.8386 0.1565 0.8259 0.1408 0.8259",
    "H0.1006",
    "C0.0867 0.8259 0.0756 0.8147 0.0756 0.8009",
    "V0.6966",
    "C0.0756 0.6810 0.0629 0.6683 0.0472 0.6683",
    "H0.0267",
    "C0.0129 0.6683 0.0017 0.6571 0.0017 0.6433",
    "V0.3567",
    "C0.0017 0.3429 0.0129 0.3317 0.0267 0.3317",
    "H0.0472",
    "C0.0629 0.3317 0.0756 0.3190 0.0756 0.3034",
    "V0.1892",
    "C0.0756 0.1754 0.0867 0.1642 0.1006 0.1642",
    "H0.1408",
    "C0.1565 0.1642 0.1692 0.1515 0.1692 0.1359",
    "V0.0956",
    "C0.1692 0.0818 0.1803 0.0706 0.1942 0.0706",
    "H0.3034",
    "C0.3190 0.0706 0.3317 0.0580 0.3317 0.0423",
    "V0.0267",
    "C0.3317 0.0129 0.3429 0.0017 0.3567 0.0017Z",
].join(" ");

export function RoomMaskDefs() {
    return (
        <svg width="0" height="0" className="absolute">
            <defs>
                <clipPath id="room-mask-obbox" clipPathUnits="objectBoundingBox">
                    <path d={normalizedPath} />
                </clipPath>
            </defs>
        </svg>
    );
}